<mat-nav-list>
    <mat-nav-list>
        <span *ngFor="let item of menu">
            <span *ngIf="item.children && item.children.length > 0">
                <mat-accordion>
                    <mat-expansion-panel>
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <!-- Cabeçalho -->
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <mat-icon>{{item.iconName}}</mat-icon>
                                    {{item.displayName}}
                                </div>
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <span *ngFor="let child of item.children">
                            <mat-list-item *ngIf="!child.children" (click)='navegar(child.route)'>
                                <!-- SubItens  -->
                                <div fxLayout="row" fxLayoutAlign="space-between center">
                                    <mat-icon>{{child.iconName}}</mat-icon>
                                    {{child.displayName}}
                                </div>
                            </mat-list-item>


                            <!-- SubMenu  -->
                            <mat-expansion-panel style="box-shadow: none;" *ngIf="child.children">
                                <mat-expansion-panel-header>
                                    <mat-panel-title style="margin-left: -7px; font-size: 16px;">
                                        <!-- Cabeçalho -->
                                        <div fxLayout="row" fxLayoutAlign="space-between center">
                                            <mat-icon>{{child.iconName}}</mat-icon>
                                            {{child.displayName}}
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>

                                <span *ngFor="let child of child.children">
                                    <mat-list-item (click)='navegar(child.route)'
                                        style="border-bottom: black; border-bottom-width: 2px;">
                                        <!-- SubItens  -->
                                        <div fxLayout="row" fxLayoutAlign="space-between center">
                                            <mat-icon>{{child.iconName}}</mat-icon>
                                            {{child.displayName}}
                                        </div>
                                    </mat-list-item>
                                </span>
                            </mat-expansion-panel>

                        </span>
                    </mat-expansion-panel>
                </mat-accordion>
            </span>
            <span *ngIf="!item.children || item.children.length === 0">
                <mat-list-item (click)='navegar(item.route)'>
                    <!-- Itens sem grupos -->
                    <div fxLayout="row" fxLayoutAlign="space-between center">
                        <mat-icon>{{item.iconName}}</mat-icon>
                        {{item.displayName}}
                    </div>
                </mat-list-item>
            </span>
        </span>
    </mat-nav-list>

    <!-- <mat-divider></mat-divider> -->
    <h2 matSubheader style="justify-content: center;">
        <mat-icon style="font-size: 18px; margin-top: 4px;">settings</mat-icon>
        <div style="margin-left: -20px">Versão {{sVersao}}</div>
    </h2>

    <div class="row">
        <div class="col-sm text-center">
            <div style="font-size: 11px;"><a target="_blank"
                    href="https://www.primeinfor.com.br/">Copyright &copy; 2021 &mdash; Prime
                    Automação</a></div>
        </div>
    </div>

</mat-nav-list>